export function getTrafficLightColor(pct: number): string {
  if (pct >= 80) return "var(--color-success, #16a34a)";
  if (pct >= 30) return "var(--color-warning, #d97706)";
  return "var(--color-danger, #dc3545)";
}
